const DownloadCVIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1V11.1111M8 11.1111L11.1111 7.70833M8 11.1111L4.88889 7.70833M10.3333 15H5.66667C3.46678 15 2.36684 15 1.68342 14.3166C1 13.6331 1 12.5332 1 10.3333M15 10.3333C15 12.5332 15 13.6331 14.3166 14.3166C14.0834 14.5497 13.8018 14.7034 13.4444 14.8045"
        stroke="#1C274C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadCVIcon;
